export const SAVE_SESSION_NOTES_LOG_PREFIX = '[SAVE_SESSION_NOTES]';
export const DURATION_POLLING_LOG_PREFIX = '[DURATION_POLLING]';
export const GET_SESSION_NOTE_WITH_AI_LOG_PREFIX = '[GET_SESSION_NOTE_WITH_AI]';
export const SAVE_APPOINTMENT_LOG_PREFIX = '[SAVE_APPOINTMENT]';
export const ADMIN_GET_APPOINTMENT_LOG_PREFIX = '[ADMIN_GET_APPOINTMENT]';
export const APPOINTMENT_API_ROUTE_LOG_PREFIX = '[APPOINTMENT_API_ROUTE]';
export const GET_USER_ORGANIZATION_LOG_PREFIX = '[GET_USER_ORGANIZATION]';
export const GENERATE_SOAP_NOTE_PREFIX = '[GENERATE_SOAP_NOTE]';
export const GENERATE_TEST_SOAP_NOTE_PREFIX = '[GENERATE_TEST_SOAP_NOTE]';
export const POSTMARK_CLIENT = '[POSTMARK_CLIENT]';
export const SEND_REVIEW_SESSION_NOTES_REMINDER =
  '[SEND_REVIEW_SESSION_NOTES_REMINDER]';
export const SAVE_FOLLOW_UP_NOTE_PREFIX = '[SAVE_FOLLOW_UP_NOTE]';
export const AI_FOLLOWUP = '[AI_FOLLOWUP]';
export const FOLLOW_UP_NOTE_LOG_PREFIX = '[FOLLOW_UP_NOTE]';
export const GET_HEALTHIE_CHARTING_NOTE_LOG_PREFIX =
  '[GET_HEALTHIE_CHARTING_NOTES]';
export const MEAL_PLAN_INSTRUCTIONS_LOG_PREFIX = '[MEAL_PLAN_INSTRUCTIONS]';
export const MEAL_PLAN_SUMMARY_LOG_PREFIX = '[MEAL_PLAN_SUMMARY]';
export const MEAL_PLAN_DETAILED_LOG_PREFIX = '[MEAL_PLAN_DETAILED_LOG_PREFIX]';
export const SESSION_DETAILS_LOG_PREFIX = '[SESSION_DETAILS]';
export const GET_TASKS_LOG_PREFIX = '[GET_TASKS]';
export const APPROVE_SESSION_NOTES_LOG_PREFIX = '[APPROVE_SESSION_NOTES]';
export const SEND_MEAL_PLAN_ERROR_LOG_PREFIX = '[SEND_MEAL_PLAN_ERROR]';
export const PATIENT_APP_API_ERROR_LOG_PREFIX = '[PATIENT_APP_API_ERROR]';
export const PDF_GENERATION_API_ERROR_LOG_PREFIX =
  '[PDF_GENERATION_API_ERROR_LOG_PREFIX]';
export const GENERATE_DAILY_LINK_LOG_PREFIX = '[GENERATE_DAILY_LINK]';
export const GET_FOLLOW_UP_CLIENTS_LOG_PREFIX = '[GET_FOLLOW_UP_CLIENTS]';
export const GET_HEALTHIE_INSURANCE_DETAILS_LOG_PREFIX =
  '[GET_HEALTHIE_INSURANCE_DETAILS_LOG_PREFIX]';
export const END_CALL_LOG_PREFIX = '[END_CALL]';

export const UPDATE_APPOINTMENT_STATUS_LOG_PREFIX =
  '[UPDATE_APPOINTMENT_STATUS]';
export const CLOSEABLE_API_LOG_PREFIX = '[CLOSEABLE API]';
export const INVALID_API_KEY_LOG_PREFIX = '[INVALID_API_KEY]';
export const ADMIN_TRANSCRIPTS_LOG_PREFIX = '[ADMIN_TRANSCRIPTS]';
export const RECURRING_FOLLOW_UPS_LOG_PREFIX = '[RECURRING_FOLLOW_UPS]';
export const RUDDERSTACK_ANALYTICS_ERROR_LOG_PREFIX =
  '[RUDDERSTACK_ANALYTICS_ERROR]';
export const SUPERVISING_STATUS_LOG_PREFIX = '[SUPERVISING_STATUS]';
export const SUPERVISED_APPOINTMENTS_REVIEW_LOG_PREFIX =
  '[SUPERVISED_APPOINTMENTS_REVIEW]';
export const GET_INVOICES_LOG_PREFIX = '[GET_INVOICES]';
export const CREATE_INVOICE_REQUEST_LOG_PREFIX = '[CREATE_INVOICE_REQUEST]';
export const W9_MANAGEMENT_LOG_PREFIX = '[W9_MANAGEMENT]';
export const TEMPLATE_FILTERING_LOG_PREFIX = '[TEMPLATE_FILTERING]';
export const IN_SESSION_TEMPLATES_LOG_PREFIX = '[IN_SESSION_TEMPLATES]';
export const SESSION_RECAP_LOG_PREFIX = '[SESSION_RECAP]';
export const SESSION_PREP_LOG_PREFIX = '[SESSION_PREP]';
export const FACTOR_MEAL_SUMMARY_LOG_PREFIX = '[FACTOR_MEAL_SUMMARY]';
export const AI_CLIENT_LOG_PREFIX = '[AI_CLIENT]';
export const GROUP_PRACTICE_LOG_PREFIX = '[GROUP_PRACTICE]';
export const EDITOR_LOG_PREFIX = '[EDITOR]';
export const DAILY_ROOM_RECREATE_PREFIX = '[DAILY_ROOM_RECREATE]';
export const MEETING_TOKEN_LOG_PREFIX = '[MEETING_TOKEN]';
export const POST_SESSION_NOTE_LOG_PREFIX = '[POST_SESSION_NOTE]';
export const NOTIFICATIONS_LOG_PREFIX = '[NOTIFICATIONS]';
export const CANCELLATION_FEES_LOG_PREFIX = '[CANCELLATION_FEES]';
export const PROVIDER_SCORES_LOG_PREFIX = '[PROVIDER_SCORES]';
export const HEALTHIE_ICD_CODES_LOG_PREFIX = '[HEALTHIE_ICD_CODES]';
export const BENEFIT_CHECK_REQUEST_LOG_PREFIX = '[BENEFIT_CHECK_REQUEST]';
export const M2M_AUTH_LOG_PREFIX = '[M2M_AUTH]';
export const ANNOUNCEMENTS_LOG_PREFIX = '[ANNOUNCEMENTS]';
export const ABANDONED_CALL_CRON_LOG_PREFIX = '[ABANDONED_CALL_CRON]';
export const INVOICE_REVIEW_LOG_PREFIX = '[INVOICE_REVIEW]';
export const NON_APPOINTMENT_HOURS_LOG_PREFIX = '[NON_APPOINTMENT_HOURS]';
export const INTRO_VIDEO_LOG_PREFIX = '[INTRO_VIDEO]';
export const PRESCRIBER_STATUS_LOG_PREFIX = '[PRESCRIBER_STATUS]';
